import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from 'moment';
import { sub } from "date-fns";

const AddSampleBrackage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const selectInputRef = useRef();
    const [invoiceDate, setInvoiceDate] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [partyData, setPartyData] = useState([]);
    const [products, setProducts] = useState([]);
    const [items, setItems] = useState([]);
    const [productData, setProductData] = useState({
        name: "",
        product_id: null,
        sub_product_id: null,
        qty: "",
    });
    const [formData, setFormData] = useState({
        "party_id": "",
        "date": "",
        "items": []
    });
    const styles = {
        menu: (baseStyles, state) => ({
            ...baseStyles,
            marginTop: 2,
            zIndex: 999,
        }),
    };

    const getParty = () => {
        axios.post(API_URL.PARTY_LIST, { is_seller: [0, 1] }).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                let pt = res.data.data.map((raw) => {
                    return {
                        name: raw.name,
                        label: raw.name + " - " + raw.contact_no,
                        value: raw.id,
                    };
                });
                setPartyData(pt);
            }
        });
    }

    const getEdit = () => {
        axios.post(API_URL.SAMPLES_GET, { id: id }).then((res) => {
            if (res.data.status == 1) {
                setFormData({
                    "party_id": (res.data.data.party_id) ? res.data.data.party_id : "",
                    "date": (res.data.data.date) ? res.data.data.date : "",
                    "items": [],
                });
                if (res.data.data.date) {
                    setInvoiceDate(new Date(res.data.data.date));
                }
                let rows = res.data.data.items.map((row) => {
                    return {
                        name: row.product.name + (row.subproduct ? " - " + row.subproduct.name : ""),
                        qty: row.qty,
                        product_id: row.product_id,
                        sub_product_id: row.sub_product_id,
                    }
                });
                setItems(rows);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
        });
    }

    const getProducts = () => {
        axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                res.data.data.map((raw) => {
                    raw.label = raw.name;
                    raw.value = raw.id;
                });
                setProducts(res.data.data);
            }
            if (!id) {
                setLoading(false);
            }
        });
    };
    const setProductValue = (e) => {
        if (e) {
            setProductData({
                ...productData,
                name: e ? e.label : "",
                product_id: e ? e.product_id : null,
                sub_product_id: e ? e.sub_product_id : null,
            });
        }
    };
    const addRow = () => {
        if (
            productData.product_id &&
            productData.qty
        ) {
            let cloneItems = [...items];
            cloneItems.push(productData);
            setItems(cloneItems);
            setProductData({
                name: "",
                product_id: "",
                sub_product_id: "",
                qty: "",
            });
            selectInputRef.current.clearValue();
        }
    };
const updateValue = (field, value, k) => {
  const copyData = [...items];
  if (copyData[k]) {
    copyData[k][field] = value;
  }
  setItems(copyData);
};

    const deleteRow = (index) => {
        const copyData = [...items]
        let newData = copyData.filter((e, key) => {
            return key != index;
        });
        setItems(newData)
    }


    const onSave = () => {
        let payload = { ...formData };
        payload.items = [...items];
        payload.date = moment(invoiceDate).format('YYYY-MM-DD');
        const pUrl = API_URL.SAMPLES_SAVE;
        if (id) {
            payload.sample_id = id;
        }
        setIsLoading(true);
        axios.post(pUrl, payload).then((res) => {
            if (res.data.status === 1) {
                if (id) {
                    toast.success("Updated", {
                        autoClose: 3000,

                    });
                } else {
                    toast.success("Saved", { autoClose: 3000 });
                }
                setTimeout(() => {
                    navigate("/sales/sample-brackage", { replace: true });
                }, 100);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setIsLoading(false);
        }, (error) => {
            setIsLoading(false);
        });
    }


    useEffect(() => {
        getParty();
        getProducts();
    }, [])

    useEffect(() => {
        if (id) {
            getEdit()
        }
    }, [id])
    return (
        <>

            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Sample & Brackage</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/sales/sample-brackage"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="card">
                                    <h4 className="card-header">Party Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="name">Party<span className="required-star">*</span></label>
                                                    <Select
                                                        options={partyData}
                                                        value={partyData.find((r) => r.value == formData.party_id)}
                                                        styles={styles}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, party_id: e.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="">Date<span className="required-star">*</span></label>
                                                    <DatePicker
                                                        format={'dd/MM/y'}
                                                        className="form-control"
                                                        onChange={setInvoiceDate}
                                                        value={invoiceDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <h4 className="card-header">Product Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Product<span className="required-star">*</span></label>
                                                    <Select
                                                        ref={selectInputRef}
                                                        options={products}
                                                        styles={styles}
                                                        onChange={(e) => {
                                                            setProductValue(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="qty">Qty<span className="required-star">*</span></label>
                                                    <input
                                                        type="number"
                                                        id="qty"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                qty: e.target.value,
                                                            });
                                                        }}
                                                        value={productData.qty}
                                                        className="form-control"
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <div>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            {items.length > 0 &&
                                <table className='table table-hover'>
                                    <thead className='thead'>
                                        <tr>
                                            <th>#</th>
                                            <th style={{ width: '45%' }}>Product</th>
                                            <th>Qty</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items.map((e, k) => {
                                                return <tr key={k}>
                                                    <td>{k + 1}</td>
                                                    <td style={{ width: '45%' }}>{e.name}</td>
                                                    <td><input type="number" onChange={(event) => updateValue('qty', event.target.value, k)}className="form-control form-control-sm" value={e.qty} /></td>
                                                    <td style={{ cursor: "pointer", textAlign: 'right' }}>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            }
                        </div>
                    </form>
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <div className="form-group text-right">
                            <button
                                type="button"
                                onClick={onSave}
                                // disabled={!isValidForm() || isLoading}
                                className="btn btn-primary" >
                                {isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status"></span> : null}
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddSampleBrackage;